<template>
  <div class="pop-up-container">
    <div class="container">
      <div class="balance">
        <p class="text-balance-main">{{ balance }} ADA</p>
        <div class="address pointer" @click="showPopUp = true">
          <div class="loader-container" v-if="isLoading">
            <span class="text-address">Pending...</span>
            <app-loader
              style="padding-top: 6px"
              :show="isLoading"
              :isGreen="true"
              :is-small="true"
            />
          </div>
          <div class="address" v-else>
            <p class="text-address">
              {{ reduceAddress(6, 4) }}
            </p>
          </div>
        </div>
      </div>
      <img
        v-if="userIsRegistered()"
        alt="user-profile-image"
        class="address-icons pointer"
        :src="userProfileImage()"
        @click="closePopUp()"
      />
      <img
        v-else
        alt="user-profile-image"
        class="address-icons pointer"
        :src="userProfileImage()"
        @click="openRegistrationModal()"
      />
    </div>
    <transition name="result">
      <div v-if="showPopUp" v-click-outside="hideResults" class="pop-up">
        <div class="pop-up-header">
          <h6>Wallet</h6>
          <div class="copy-icon-wrap">
            <p class="text-address">{{ reduceAddress(10, 11) }}</p>
            <div
              class="copy-icon-box pointer"
              v-click-outside="hideCopyTooltip"
              @click="copy"
            >
              <i class="copy-icon"></i>
              <input id="selectedAddress" hidden v-model="address" />
              <div v-if="copyTooltip" class="tooltip-copy">Copied!</div>
            </div>
          </div>
          <div class="active-network">
            <div class="active-network-icon"></div>
            <div class="active-network-text">
              {{ networkName }}
            </div>
          </div>
        </div>
        <div class="pop-up-footer">
          <a class="disconnect" @click="disconnect">Disconnect</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import store from "../store";
import router from "../router";
// import { ethereumService } from "@/main";
import useAuth from "@/composables/useAuth";
import AppLoader from "../elements/AppLoader";
import { computed, onMounted, ref } from "vue";
import vClickOutside from "click-outside-vue3";
import imageTransformer from "../plugins/imageTransformer";
import { cardanoService } from "@/main";

export default {
  components: {
    AppLoader,
  },
  props: {
    id: String,
    labelText: {
      type: String,
      default: "",
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  setup() {
    const isLoading = computed(
      () => store.getters["users/getPendingTransaction"]
    );
    // const addTheosToMetamask = () => {
    //   return ethereumService.addTheosToMetamask();
    // };

    const { openRegistrationModal } = useAuth(store, null, cardanoService);
    let copyTooltip = ref(false);
    let showPopUp = ref(false);
    const address = computed(
      () => store.getters["contracts/getAddressCardano"]
    );
    console.log("UserBalanceAndAddressCardano", address);
    const balance = computed(() =>
      parseFloat(store.getters["contracts/getBalance"] || "0").toFixed(5)
    );
    // const balanceTHEOS = computed(() =>
    //   parseFloat(
    //     store.getters["contracts/getBalanceByCurrency"]("THEOS") || "0"
    //   ).toFixed(3)
    // );
    const networkName = computed(
      () => store.getters["contracts/getNetworkName"]
    );

    // const coinPriceTHEOS = computed(() => {
    //   const price = store.getters["contracts/getCoinPrice"]("theos", "usd");
    //   return price ? (price.value * balanceTHEOS.value).toFixed(0) : 0;
    // });
    onMounted(async () => {
      await store.dispatch("contracts/fetchAddressCardano");
      await store.dispatch("contracts/fetchBalance");
      //   await store.dispatch("contracts/fetchCoinPrice", {});
    });
    const disconnect = async () => {
      await store.dispatch("auth/disconnect");
      await store.dispatch("contracts/resetState");
      await cardanoService.disconnectProvider();
      location.reload();
      await router.push("/");
    };
    const copy = () => {
      copyTooltip.value = true;
      navigator.clipboard.writeText(address.value);
    };
    const reduceAddress = (lengthLeft, lengthRight) => {
      if (address.value) {
        const addressLeftPart = address.value.substring(0, lengthLeft);
        const addressRightPart = address.value.substring(42 - lengthRight, 42);
        return `${addressLeftPart}...${addressRightPart}`;
      }
      return "Not connected";
    };
    const hideCopyTooltip = () => {
      copyTooltip.value = false;
    };
    const hideResults = () => {
      showPopUp.value = false;
    };
    const userProfileImage = () => {
      const profileImage = store.getters["userProfile/getUser"].profileImage;
      return profileImage
        ? imageTransformer.transform(profileImage.filename, "user.avatar")
        : require("@/Common/Icons/Avatar.png");
    };

    const userIsRegistered = () =>
      store.getters["userProfile/getUser"].displayName;

    const closePopUp = () => {
      showPopUp.value = false;
      router.push("/profile");
    };

    return {
      copy,
      address,
      networkName,
      isLoading,
      //   coinPriceTHEOS,
      showPopUp,
      closePopUp,
      disconnect,
      hideResults,
      copyTooltip,
      reduceAddress,
      balance,
      //   balanceTHEOS,
      hideCopyTooltip,
      userIsRegistered,
      userProfileImage,
      //   addTheosToMetamask,
      openRegistrationModal,
    };
  },
};
</script>

<style
  lang="scss"
  scoped
  src="@/Common/Styles/UserBalanceAndAddressCardano.scss"
></style>
